// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"f289b816","349":"b78338a9","787":"8a207363","821":"b029c827"}[chunkId] + ".chunk.js";
};